import React, { FC } from 'react';

import { EvFlexRow, EvSkeleton } from '@evinced-private/ui-common';

import { SummaryLineSkeleton } from 'src/apps/web-sdks/components/skeletons/summary-line-skeleton/SummaryLineSkeleton';
import { FilterRows } from 'src/common/components/skeletons/FilterRows';
import { TableSkeleton } from 'src/common/components/skeletons/table-skeleton/TableSkeleton';

import './WebSdkTestsSkeleton.scss';

interface WebSdkTestsSkeletonProps {
	isAnimated?: boolean;
}

export const WebSdkTestsSkeleton: FC<WebSdkTestsSkeletonProps> = ({ isAnimated = true }) => {
	const animationSpeed = isAnimated ? undefined : 0;
	const filterHeight = '60px';

	return (
		<div className="web-sdk-tests-skeleton">
			{/* Main title skeleton with show-recent toggle on the right */}
			<EvFlexRow
				justify="SPACE_BETWEEN"
				align="CENTER"
				gap="MEDIUM"
				margin={['NONE', 'NONE', 'LARGE', 'NONE']}
			>
				<EvSkeleton height="28px" width="170px" animationSpeed={animationSpeed} />
				<EvSkeleton width="285px" height="24px" animationSpeed={animationSpeed} />
			</EvFlexRow>

			{/* Filters section skeleton */}
			<div className="skeleton-filters-section">
				<div className="skeleton-filters-rows">
					<FilterRows
						count={1}
						height={filterHeight}
						width="270px"
						animationSpeed={animationSpeed}
						keySet={['search']}
					/>
					<FilterRows
						count={2}
						height={filterHeight}
						width="136px"
						animationSpeed={animationSpeed}
						keySet={Array.from({ length: 2 }, (_, i) => `filter_${i}`)}
					/>
					<FilterRows
						count={2}
						height="40px"
						width="70px"
						animationSpeed={animationSpeed}
						keySet={Array.from({ length: 2 }, (_, i) => `action_${i}`)}
					/>
				</div>
			</div>

			{/* Horizontal divider */}
			<div className="skeleton-divider" />

			{/* Usage summary section skeleton */}
			<div className="skeleton-usage-section">
				<div className="skeleton-section-title">
					<EvSkeleton height="23px" width="110px" animationSpeed={animationSpeed} />
				</div>
				<div className="skeleton-summary-subtitle">
					<EvSkeleton height="14px" width="180px" animationSpeed={animationSpeed} />
				</div>
				<SummaryLineSkeleton animationSpeed={animationSpeed} />
			</div>

			{/* Table section skeleton */}
			<div className="skeleton-table-section">
				<div className="skeleton-section-title">
					<EvSkeleton height="23px" width="150px" animationSpeed={animationSpeed} />
				</div>
				<div className="skeleton-table-section__action_row">
					<EvSkeleton height="24px" width="295px" animationSpeed={animationSpeed} />
					<div className="skeleton-section-table-actions-spacer" />
					<div className="skeleton-table-section__action_row__buttons">
						<EvSkeleton height="40px" width="110px" animationSpeed={animationSpeed} />
						<EvSkeleton height="40px" width="174px" animationSpeed={animationSpeed} />
						<EvSkeleton height="40px" width="134px" animationSpeed={animationSpeed} />
					</div>
				</div>
				<div className="skeleton-table-content">
					<TableSkeleton columns={5} rowCount={7} showActions={true} rowHeight="120px" />
				</div>
			</div>
		</div>
	);
};
